













import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api'
import ProductIncludes from './ProductIncludes.vue'
import ProductInformationSupportingData from './ProductInformationSupportingData.vue'
import { PRODUCT_TYPES } from '~/common/utils/product/constants'
import { MappedProduct } from '~/types/product/productTypes'

export default defineComponent({
  components: {
    ProductIncludes,
    ProductInformationSupportingData,
  },
  props: {
    product: {
      type: Object as () => MappedProduct,
      required: true,
    },
  },
  setup() {
    const showDivider = ref(false)
    const productInfoSection = ref<HTMLElement>()

    onMounted(() => {
      showDivider.value = productInfoSection.value?.clientHeight === 0
    })

    return {
      showDivider,
      productInfoSection,
      PRODUCT_TYPES,
    }
  },
})
